// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_2ClCZ","tips":"_2FAmR","bg":"_3rY6t"};